import { jsx as c, jsxs as d, Fragment as p } from "react/jsx-runtime";
import { c as g, $ as i } from "../../vendor-DgBgaXRO.js";
import { forwardRef as h } from "react";
import { getButtonStyles as u } from "../BaseButton/index.js";
import { BaseIcon as y } from "../BaseIcon/index.js";
import { isIconName as B } from "../BaseIcon/typeGuards.js";
import { withTooltip as V } from "../Tooltip/withTooltip.js";
import '../../assets/index2.css';const W = "pVf69W_hasLabel", _ = "pVf69W_heart", b = "pVf69W_md", $ = "pVf69W_pin", x = "pVf69W_secondary", I = "pVf69W_sm", L = "pVf69W_star", N = "pVf69W_toggleButton", o = {
  hasLabel: W,
  heart: _,
  md: b,
  pin: $,
  secondary: x,
  sm: I,
  star: L,
  toggleButton: N
};
function T({ size: s = "md", variant: t = "secondary", children: e, icon: a, ...n }, m) {
  const f = g(
    u({
      size: s,
      variant: t === "secondary" ? "secondary" : "ghost",
      ...n
    }),
    o.toggleButton,
    e ? o.hasLabel : void 0,
    o[t],
    o[s]
  );
  return /* @__PURE__ */ c(i, { ...n, className: f, ref: m, children: ({ isSelected: l }) => {
    const r = t === "secondary" ? a : `${t}${l ? "-filled" : ""}`;
    return /* @__PURE__ */ d(p, { children: [
      B(r) && /* @__PURE__ */ c(y, { icon: r, size: s, className: o.icon }),
      e
    ] });
  } });
}
const v = V(h(T));
export {
  v as ToggleButton
};
//# sourceMappingURL=index.js.map
